import { HttpErrorResponse } from '@angular/common/http';
import { UpperCasePipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  TranslocoModule,
  TranslocoService,
  provideTranslocoScope,
} from '@jsverse/transloco';
import { ESQEP_AUTH_TYPE } from 'app/core/constants/constants.component';
import { LoggedInUser } from 'app/core/models/person/logged-in-user.model';
import {
  AlertData,
  AlertLevels,
  AlertService,
} from 'app/core/services/alert/alert.service';
import { AuthService } from 'app/core/services/auth/auth.service';
import { AUTHENTICATION_CONFIGURATION_NAMES } from 'app/core/services/auth/authenticationConfigNames';
import { PersonService } from 'app/core/services/person/person.service';
import { BrowserStorageService } from 'app/core/utilities';
@Component({
  selector: 'sqep-person-detail-navbar',
  imports: [MatMenuModule, MatButtonModule, MatIconModule, TranslocoModule, UpperCasePipe],
  templateUrl: './person-detail-navbar.component.html',
  styleUrls: ['./person-detail-navbar.component.scss'],
  providers: [provideTranslocoScope('person-details')],
})
export class PersonDetailNavbarComponent implements OnInit {
  private readonly service = inject(TranslocoService);
  private readonly storageService = inject(BrowserStorageService);
  private readonly alertService = inject(AlertService);
  private readonly authService = inject(AuthService);
  private readonly personService = inject(PersonService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  protected readonly person = toSignal<LoggedInUser>(
    this.authService.loggedInUserSubj,
  );
  protected readonly personPhotoUrl = signal<SafeResourceUrl>(null);
  protected readonly hasPhoto = signal<boolean>(false);

  exceptionData = {
    PERSON_UUID: {
      level: AlertLevels.ERROR,
      code: 'PDT-001',
      message: 'Unable to retrieve user data',
    } as AlertData,
    PERSON_PHOTO: {
      level: AlertLevels.WARNING,
      code: 'PDT-002',
      message: 'Unable to retrieve user photo',
    } as AlertData,
  };

  // protected availableLangs =
  //   this.service.getAvailableLangs() as LangDefinition[];

  // get activeLang() {
  //   return this.service.getActiveLang();
  // }

  // changeLang(lang: string) {
  //   this.service
  //     .load(lang)
  //     .pipe(take(1))
  //     .subscribe(() => {
  //       this.service.setActiveLang(lang);
  //     });
  // }

  ngOnInit() {
    if (
      this.storageService.get(ESQEP_AUTH_TYPE) ===
      AUTHENTICATION_CONFIGURATION_NAMES.ENTRA
    ) {
      this.personService
        .getPersonPhoto('48x48')
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (photo) => {
            if (photo) {
              let photoUrl = '';
              const photoBlob = new Blob([photo], { type: photo.type });
              if (
                photoBlob.type === 'image/jpeg' ||
                photoBlob.type === 'image/png'
              ) {
                photoUrl = window.URL.createObjectURL(photoBlob);
                this.personPhotoUrl.set(
                  this.sanitizer.bypassSecurityTrustResourceUrl(photoUrl),
                );
                this.hasPhoto.update(() => true);
              }
            } else {
              this.personPhotoUrl.set(null);
              this.hasPhoto.update(() => true);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.alertService.createAlert2(
              this.exceptionData.PERSON_PHOTO,
              error,
            );
          },
        });
    } else {
      this.personPhotoUrl.set(null);
      this.hasPhoto.update(() => true);
    }
  }

  logout() {
    this.authService.logout();
  }

  myDetails() {
    this.router.navigate(['/person/details']);
  }
}
